import UserApplicationLayout from '@/layouts/UserApplicationLayout'

export default {
  path: '/orders',
  component: UserApplicationLayout,
  redirect: '/orders/list',
  children: [
    {
      path: 'list',
      component: () => import('@/views/orders/List'),
      meta: {
        // keepAlive: true
        // auth: Auth.listStationActivities
      }
    }
  ]
}
